module.exports = __webpack_public_path__ + "static/media/snow_privatization.c7709dbb.md";